<template>
  <div class="base-states-edit-screen" ref="baseStatesEditScreen">
    <div class="row mt-20 mb-20">
      <div class="col-sm-6">
        <h3>{{$t('app.base_states.plan_title')}}</h3>
        <h6>{{partnerName}}</h6>
      </div>
    </div>
    <verification-question-filter :isEdit="true" @filter="filter"/>
    <div
      v-if="verificationQuestion && !planningEnd"
      class="panel panel-default border-panel card-view"
    >
      <div class="panel-body">
        <div class="row">
          <verification-question-screen
            :model="verificationQuestion"
            :questionTitle="questionTitle"
          />
          <statement-screen ref="statementScreen" :model="currentStatement"/>
        </div>
        <button-row
          @notExplainable="notExplainableClicked"
          @save="saveClicked"
          @skip="skipClicked"
          @saveDraft="saveDraftClicked"
        />
      </div>
    </div>
    <div class="empty-section" v-if="!verificationQuestion">{{$t('app.base_states.no_result')}}</div>
    <div
      class="empty-section"
      v-if="planningEnd && verificationQuestion"
    >{{$t('app.base_states.end_planning')}}</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VerficiationQuestionFilter from './VerficiationQuestionFilter';
import VerificationQuestionScreen from './VerificationQuestionScreen';
import StatementScreen from './StatementScreen';
import ButtonRow from './ButtonRow';
import Notification from '@/components/shared/notifications/Notification';

export default {
  name: 'BaseStateEditScreen',
  components: {
    'verification-question-filter': VerficiationQuestionFilter,
    'verification-question-screen': VerificationQuestionScreen,
    'statement-screen': StatementScreen,
    'button-row': ButtonRow,
    notification: Notification,
  },
  props: {},
  data() {
    return {
      control_frequency: 'control_frequency',
      newMessage: '',
      currentIndex: 0,
      verificationQuestions: undefined,
      currentStatement: {},
      statements: [],
      imagePath: 'static/avatar.png',
      categoryId: undefined,
      planningEnd: false,
    };
  },
  created() {
    this.fetchCommonData(this.commonData.partner.id);
  },
  computed: {
    ...mapGetters({
      commonData: 'partners/commonData',
    }),
    partnerName() {
      if (!this.commonData) {
        return '';
      }
      return this.commonData.partner.name;
    },
    verificationQuestion() {
      if (!this.verificationQuestions) {
        return undefined;
      }
      return this.verificationQuestions[this.currentIndex];
    },
    questionTitle() {
      return this.$t('app.base_states.question_title', {
        currentIndex: this.currentIndex + 1,
        count: this.verificationQuestions.length ,
      });
    },
  },
  methods: {
    ...mapActions({
      searchVerificationQuestions:
        'verificationQuestions/searchVerificationQuestions',
      updateStatement: 'statements/updateStatement',
      fetchCommonData: 'partners/fetchCommonData',
    }),
    filter(criteria) {
      this.categoryId = criteria.categoryId;
      this.searchVerificationQuestions(criteria).then((response) => {
        this.verificationQuestions = response;
        if (this.verificationQuestions[this.currentIndex] !== undefined) {
          this.currentStatement = this.verificationQuestions[
            this.currentIndex
          ].statement;
        }
      });
    },
    saveDraftClicked() {
      this.saveWithState(2);
    },
    skipClicked() {
      const statementField = this.$refs.statementScreen.$refs.messageField;
      if (this.currentIndex + 1 === this.verificationQuestions.length) {
        this.planningEnd = true;
      }
      this.currentIndex = Math.min(
        this.currentIndex + 1,
        this.verificationQuestions.length - 1,
      );
      this.currentStatement = this.verificationQuestions[
        this.currentIndex
      ].statement;
      statementField.content = this.currentStatement.statement;
      this.$refs.statementScreen.refreshStatement(
        this.currentStatement.locations,
      );
    },
    saveClicked() {
      this.saveWithState(0);
    },
    notExplainableClicked() {
      this.saveWithState(1);
    },
    saveWithState(state) {
      this.currentStatement.verification_question_id = this.verificationQuestion.id;
      this.currentStatement.criteria_category_id = this.categoryId;
      this.currentStatement.state = state;
      // Map locations back
      this.currentStatement.location_ids = this.currentStatement.locations.map(
        x => x.id,
      );
      this.updateStatement(this.currentStatement).then((response) => {
        this.$refs.baseStatesEditScreen.scrollTop = 0;
        this.skipClicked();
        this.$eventBus.showNotification({
          notificationText: this.$t('app.base_states.notifications.success'),
          notificationType: 'success',
        });
      });
    },
  },
};
</script>

<style lang="scss">
.base-states-edit-screen {
  .rounded {
    border-radius: 4px;
  }

  .center-row {
    display: flex;
    align-items: center;
  }

  .category-tag {
    background: var(--main-color);
    border-radius: 4px;
    color: #ffffff;
    font-size: 11px;
    padding: 3px 9px 3px 9px;
    text-align: center;
  }

  .question-title {
    float: left;
    text-align: center;
    margin-right: 2px;
  }

  .question-name-field {
    margin-left: 10px;
    width: 50%;
    font-size: 14px;
  }

  .legal-reference {
    margin-left: 10px;
    font-size: 14px;
  }

  .legal-description {
    width: 50%;
    margin-left: 10px;
    font-size: 14px;
  }

  textarea {
    resize: none;
    width: 100%;
    height: 134px;
    padding: 15px;
    border-radius: 4px;
  }

  .right-buttons {
    display: flex;
    justify-content: flex-end;
  }

  .button {
    min-width: 190px;
  }

  .icon-field {
    min-width: 0% !important;
  }

  .upload-drop-zone {
    line-height: 70px !important;
  }

  .uploader {
    margin: 20px;
  }
  .empty-section {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/base_states/BaseStateEditScreen.vue